import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
        },
        position: 'relative',
        backgroundColor: colors.background.BLACK,
        placeContent: 'center',
        '& div[data-testid="desktopImage"]': {
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                width: '50%',
            },
        },
    },
    heading: Object.assign(Object.assign(Object.assign({ textAlign: 'left', color: colors.primary.gold4 }, theme.typography.large_bold), theme.typographySpacing.large_bold_lg), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), '& span': {
            marginBottom: 0,
        } }),
    newMessage: {
        '&': {
            marginBottom: 0,
            paddingTop: 0,
        },
        [theme.breakpoints.up('lg')]: Object.assign({}, theme.typography.medium_regular),
        '& p, & div': Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_bold_lg), { color: colors.supplementary.white, marginBottom: spacing.small }),
    },
    linkContainer: {
        width: '100%',
    },
    contentContainer: {
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
        },
    },
    innerContent: {
        [theme.breakpoints.up('md')]: {
            margin: spacing.large,
        },
    },
    image: {
        paddingTop: '100%',
        minHeight: '200px ',
        [theme.breakpoints.up('xs')]: {
            paddingTop: 0,
        },
        '& img': {
            objectFit: 'cover',
        },
    },
}));
export default useStyles;
